// Core
import React from "react"

// Components
import ScrollSection from "../locomotiveScroll/scrollSection"

// Style
import styles from "./image.module.scss"

const Image = ({ fluid, description }) => {

  return (
    <ScrollSection>
      <div className={styles.wrap}>
        <img src={fluid.src} width={1800} height={886} alt={description} />
      </div>
    </ScrollSection>
  )
}

export default Image